import {DialogTitleProps} from "./FormDialogComponent";
import {DialogTitle, IconButton, useTheme} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

const BootstrapDialogTitle = (props: DialogTitleProps) => {
    const {children, onClose, ...other} = props;

    // Use Theme
    const theme = useTheme();

    return (
        <DialogTitle
            sx={{
                display: "flex",
                justifyContent: props.end ? props.end : "space-between",
                color: theme.palette.primary.main
            }} {...other} >
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

export default BootstrapDialogTitle;